import { render, staticRenderFns } from "./Registration3VerifyPhone.vue?vue&type=template&id=47b2f6a8&"
import script from "./Registration3VerifyPhone.vue?vue&type=script&lang=js&"
export * from "./Registration3VerifyPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VOtpInput } from 'vuetify/lib/components/VOtpInput';
installComponents(component, {VBtn,VForm,VOtpInput})
